import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import styled from "styled-components"
import useWindowDimensions from "../../../hooks/useWindowSize"
import { showModal } from "../../../features/modal/modalSlice"
import TopbarMenulerSm from "../../layoutItems/topbar/topbarMenuler/TopbarMenulerSm"
import Btn from "../../shared/button/Btn"
import TopbarMenulerMobile from "../../layoutItems/topbar/topbarMenuler/TopbarMenulerMobile"
import { useState } from "react"
import NavbarMobile from "../../layoutItems/sidebar/NavbarMobile"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"

const Container = styled.div`
    position: fixed;
    top: ${({mobileTopMargin}) => mobileTopMargin};
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: ${({mobileTopMargin}) => `calc(100% - ${mobileTopMargin})`};
    justify-content: center;
    align-items: center;
    z-index: 100;

    .wrapper{
        padding: 15px 30px;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: ${({theme}) => theme.mainBgColor};

    }

`

const MobileMenuModal = () => {

    const {windowDimensions} = useWindowDimensions()
    
    const {mobileTopMargin} = useSelector(state => state.layout)
    const {modalType} = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()
  
        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])
  
    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])
    
    useEffect(() => {
        if(windowDimensions.width > 850 && modalType === "mobile-menu"){
            dispatch(showModal(null))
        }
    },[modalType, windowDimensions.width])


  return (
    <Container mobileTopMargin={mobileTopMargin}>
        <div className="wrapper">
            <TopbarMenulerMobile/>
            <NavbarMobile/>

        </div>
    </Container>
  )
}

export default MobileMenuModal